/**
 * The code-split boundary for the whole admin panel (P4.6-B, D-7).
 *
 * A tiny eager wrapper whose only job is to hold the `lazy()` call plus its
 * Suspense fallback. It exists as its own file for two reasons:
 *   - main.tsx is an entry module with no exports, and defining a component
 *     (which `lazy()` returns) there trips react-refresh/only-export-components;
 *   - keeping the boundary next to the admin tree it guards means main.tsx
 *     needs to know nothing about the admin panel beyond one route.
 *
 * Only THIS file lands in the main bundle. AdminRoot and everything it pulls
 * in — both Cognito pools' worth of admin auth, the admin API client, all six
 * pages — stay in a separate chunk that a builder never downloads.
 */
import { Suspense, lazy } from "react";

// `.then` re-shapes the named export into the default `lazy()` expects,
// keeping this repo's named-export convention rather than adding a default
// export purely for lazy()'s benefit.
const AdminRoot = lazy(() =>
  import("./AdminRoot").then((m) => ({ default: m.AdminRoot })),
);

export function AdminPanel() {
  return (
    <Suspense
      fallback={
        // A real <main> + <h1>, so RouteFocusManager has a heading to focus
        // while the chunk downloads and axe's landmark-one-main /
        // page-has-heading-one rules hold in this transient state too.
        <main className="loading-screen">
          <h1>Loading admin panel…</h1>
        </main>
      }
    >
      <AdminRoot />
    </Suspense>
  );
}
